<div class="header-wrapper">
  <h1 mat-dialog-title class="titles"> {{ "title.Updatedcapacity" | translate | async }}</h1>
    <p class="title_add"  *ngIf="data.status != 'bulk'" >{{ data.title | translate | async }}</p>
    <p  class="title_add" *ngIf="data.status == 'bulk' && (data.data.capacity.type == 'new' ||data.data.capacity.type == 'add' ) " >{{ "title.pastHourCapacityNotUpdated" | translate | async }}</p>
    <p class="title" mat-dialog-content *ngIf="data.status == 'bulk' && (data.data.capacity.type == 'subtract' && data.date.todayDate >= data.date.bulkStartdate ) " >{{ "messages.pastHourCurrentcapacity" | translate | async }}</p>
    <p class="title" mat-dialog-content *ngIf="data.status == 'bulk' && (data.data.capacity.type == 'subtract' && data.date.todayDate < data.date.bulkStartdate ) ">{{ "messages.pastHourfuturecapacity" | translate | async }}</p>
</div>
<div mat-dialog-actions>
    <vue-flat-button (clicked)="closeDialog()">
      {{ "button.ok" | translate | async }}
    </vue-flat-button>
  </div>
